import React from "react";
import { Box, Button } from "@mui/material";
import { CaseWhenBenefit } from "services/GraphQl";
import BenefitProgressCircle from "./shared/BenefitProgressCircle";
import BenefitSummaryTable from "./shared/BenefitSummaryTable";

interface WhenBenefitLumpSumTrackerProps {
  whenBenefit?: CaseWhenBenefit;
  setModalOpen: (open: boolean) => void;
}

const WhenBenefitLumpSumTracker: React.FC<WhenBenefitLumpSumTrackerProps> = ({ whenBenefit, setModalOpen }) => {
  if (!whenBenefit) return null;
  const detail = whenBenefit.detail || {};

  return (
    <Box sx={{ bgcolor: "#fff", borderRadius: 3, p: { xs: 1, sm: 3 }, boxShadow: "0 1px 6px rgba(0,0,0,0.06)" }}>
      {/* Progress Circle */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <BenefitProgressCircle value={detail.amountRemaining || 0} total={detail.total || 0} />
      </Box>

      {/* Summary Table */}
      <BenefitSummaryTable
        total={detail.total || 0}
        pending={detail.amountPending || 0}
        reimbursed={detail.amountSpent || 0}
        remaining={detail.amountRemaining || 0}
      />

      {/* Make a Claim Button */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2, mb: 2 }}>
        <Button
          variant="contained"
          onClick={() => setModalOpen(true)}
          sx={{
            bgcolor: "#294441",
            color: "white",
            borderRadius: "8px",
            px: 5,
            py: 1.5,
            textTransform: "none",
            fontSize: "1.1rem",
            fontWeight: "bold",
            boxShadow: "none",
            "&:hover": { bgcolor: "#1d2f2b" },
          }}
        >
          Make A Claim
        </Button>
      </Box>
    </Box>
  );
};

export default WhenBenefitLumpSumTracker; 